import { render, staticRenderFns } from "./EditBaseHeader.vue?vue&type=template&id=ac394920&"
import script from "./EditBaseHeader.vue?vue&type=script&lang=js&"
export * from "./EditBaseHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports